// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","page":"page-1hKOE","linesWrapper":"linesWrapper-2Yqyw","topoWrapper":"topoWrapper-1dAmM","feedWrapper":"feedWrapper-nPeTU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/_appPage.css
// module id = 1169
// module chunks = 1